import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('ls-modal')
export class LsModal extends LitElement {
    @property({ type: String }) align: 'left' | 'right' = 'left';
    @property({ type: String }) ipadPosition: 'origin' | 'center' = 'center';
    @property({ type: Function }) onClose: () => void = () => {};

    static styles = css`
        :host([align='right']) .ls-modal {
            right: 0;
        }

        :host([align='left']) .ls-modal {
            left: 0;
        }

        .ls-modal {
            position: absolute;
            top: 100%;
            text-align: left;
            padding: 8px;
            background-color: #fff;
            margin-top: 10px;
            border-radius: 10px;
            box-shadow: 0px 0px 8px 0px #0000001a;
            min-width: 250px;
            z-index: 1000;
        }

        .ls-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 999;
        }

        @media (max-width: 1280px) {
            .ls-modal {
                position: fixed;
                top: 50%;
                left: 50%;
                width: fit-content;
                transform: translate(-50%, -50%);
            }
        }

        @media (min-width: 576px) and (max-width: 1280px) {
            .ls-modal.ipad-origin {
                position: absolute;
                top: 100%;
                transform: none;
            }
            :host([align='right']) .ls-modal.ipad-origin {
                left: auto;
                right: 0;
            }
            :host([align='left']) .ls-modal.ipad-origin {
                right: auto;
                left: 0;
            }
        }
    `;

    render() {
        return html`<div class="ls-modal ${'ipad-' + this.ipadPosition}">
                <slot></slot>
            </div>
            <div class="ls-modal-overlay" @click=${this.onClose}></div> `;
    }
}
